import { MsalGuard } from '@azure/msal-angular';
import { AuthFailureGuard, AuthLogoutGuard, PageLoginRedirectComponent } from '@evc/platform';
import { Route } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PrivatePageComponent } from './pages/private-page/private-page.component';

export const appRoutes: Route[] = [
  {
    // public / private routes examples
    path: '', // lets say the home is public - no `canActivate`
    pathMatch: 'full',
    component: HomeComponent,
  },
  {
    path: 'private',
    component: PrivatePageComponent,
    canActivate: [MsalGuard], // force login
  },
  // ADD THOSE REQUIRED ROUTES
  {
    path: 'logout',
    component: PageNotFoundComponent, // can be any component
    canActivate: [AuthLogoutGuard],
    data: { logout: true },
  },
  {
    path: 'auth-fail',
    component: PageNotFoundComponent, // can be any component
    canActivate: [AuthFailureGuard],
  },
  {
    path: 'login',
    canActivate: [MsalGuard],
    component: PageLoginRedirectComponent,
  },
  // Suggestion : Handle 404
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
